module.exports = __webpack_public_path__ + "static/media/yellowmedium.a865d09b.svg";